export const CVV_REQUIRED_MESSAGE =
  'The saved card has no CVV on file. Ask the user for the CVV (Payment 3DS → CVV needed) before revealing card details.';

export function cardRevealErrorMessage(
  data: { code?: string; error?: string } | undefined,
): string {
  if (data?.code === 'cvv_required_from_user') return CVV_REQUIRED_MESSAGE;
  return data?.error || 'Failed to get card details';
}
